'use client';

import { useDictionary } from '@/lib/context/locale-provider';
import { Languages } from '@/lib/dictionaries';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import React from 'react';
import classes from './header.module.scss';

function HeaderShopGuide({ lang }: { lang: Languages }) {
  const dict = useDictionary();
  const pathname = usePathname();

  if (pathname === `/${lang}` || pathname.startsWith(`/${lang}/shop/`)) {
    return (
      <Link href={`/${lang}/group-order`} className={classes.alarmLinkBtn}>
        <span className={classes.linkTxt}>{dict!.header.shopGuide}</span>
      </Link>
    );
  } else {
    return null;
  }
}

export default HeaderShopGuide;
